module.exports = __webpack_public_path__ + "static/media/wrapped-homecard-en.09815ef1.png";